exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#fake[data-v-d8f10784] {\r\n    position: absolute;\r\n    top: -15000px;\n}\r\n\r\n", ""]);

// exports
